/** @format */

import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Jtron Pages</h1>
      </header>
    </div>
  );
}

export default App;
